import * as m from "~/paraglide/messages";
import type { Locale } from "~/paraglide/runtime";

export interface LandingFaq {
  readonly question: string;
  readonly answer: string;
}

export interface LandingFaqContent {
  readonly title: string;
  readonly faqs: readonly LandingFaq[];
}

/**
 * Resolves the approved landing FAQ catalog for the active Paraglide locale.
 *
 * Homepage markup and its SSR FAQPage graph must each consume this exact
 * collection, so catalog wording cannot drift between visible and crawler
 * content. The optional locale is only for deterministic catalog assertions;
 * application rendering relies on Paraglide's active URL-aware locale.
 */
export function getLandingFaqContent(locale?: Locale): LandingFaqContent {
  const options = locale ? { locale } : undefined;

  return {
    title: m.landing_faq_title({}, options),
    faqs: [
      {
        question: m.landing_faq_1_q({}, options),
        answer: m.landing_faq_1_a({}, options),
      },
      {
        question: m.landing_faq_2_q({}, options),
        answer: m.landing_faq_2_a({}, options),
      },
      {
        question: m.landing_faq_3_q({}, options),
        answer: m.landing_faq_3_a({}, options),
      },
      {
        question: m.landing_faq_4_q({}, options),
        answer: m.landing_faq_4_a({}, options),
      },
      {
        question: m.landing_faq_5_q({}, options),
        answer: m.landing_faq_5_a({}, options),
      },
    ],
  };
}
